import { render, staticRenderFns } from "./SocialMediaButton.vue?vue&type=template&id=52b9009d&scoped=true&"
import script from "./SocialMediaButton.vue?vue&type=script&lang=ts&"
export * from "./SocialMediaButton.vue?vue&type=script&lang=ts&"
import style0 from "./SocialMediaButton.vue?vue&type=style&index=0&id=52b9009d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9009d",
  null
  
)

export default component.exports